import { SubscriptionDetails } from "../../types"

export const getStatusID = (data: SubscriptionDetails): string => {
  return data.deleted === "1"
    ? "delete"
    : data.active === "1"
    ? "active"
    : "disable"
}
